<template>
    <div class="common_container">
        <el-form label-position="right" label-width="90px"  :rules="rules" :model="form" ref="form">
            <el-form-item label="IP/CIDR" prop="ip_cidr" >
                <el-input v-model="form.ip_cidr"  placeholder="单一IP、多个IP以,分隔、CIDR" class="form-input"></el-input>
            </el-form-item>
            <el-row v-if="type == 'edit'">
                <el-form-item label="是否激活" >
                    <el-switch
                        v-model="form.is_active"
                        :active-value="1"
                        :inactive-value="0">
                    </el-switch>
                </el-form-item>
            </el-row>
            <el-form-item label="描述" prop="">
                <el-input type="textarea" v-model="form.description" placeholder="请输入" class="form-input"></el-input>
            </el-form-item>
            <el-form-item >
                <el-button type="primary" size="small" :disabled="isEnabled" @click="submit">保存</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from './system.service'
    export default {
        name: "thirdPartyUserAdd",
        props:{
          type:{
              type:String,
              default:'add'
          },
          row:Object,
          callback:Function,
        },
        data(){
            return{
                formName:"form",
                rules: {
                    ip_cidr: [
                        { required: true, message: '请输入IP/CIDR', trigger: 'blur' },
                        // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                },
                form:{
                    ip_cidr:'',
                    description:'',
                    is_active:1
                },
                isEnabled:false
            }
        },
        created(){
            if (this.type=='edit'){
                this.$modal.title = '编辑Ip白名单'
                this.form.ip_cidr = this.row.ip_cidr
                this.form.description = this.row.description
                this.form.is_active = this.row.is_active ? 1 : 0
            }else{
                this.$modal.title = '新增Ip白名单'
            }
        },
        methods:{
            submit(){
                let formName=this.formName
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.type=='edit'){
                            this.update(this.form)
                        } else{
                            this.add(this.form)
                        }

                    }
                })
            },
            add(params){
                // console.log(params)
                delete params.is_active
                services.getIpWhiteAdd(params).then(res=>{
                    this.$message.success("新增成功");
                    this.isEnabled=true
                    this.close(true);
                }).catch(err=>{
                    this.$message.error(err.message)
                })


            },
            update(params){
                let option = params
                option.id = this.row.id
                services.getIpWhiteEdit(option).then(res=>{
                    this.$message.success("编辑成功");
                    this.isEnabled=true
                    this.close(true);
                }).catch(err=>{
                    this.$message.error(err.message)
                })
            },

            //取消按钮
            onCancel(){
                this.close();
            },
            //取消后关闭页面
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        }
    }
</script>
<style>
    #useridTip{
        position: absolute;
        left: 10px;
        top: 23px;
        color: red;
    }
</style>
<style scoped type="SCSS">
    .el-form__inline{
        width:100%;
        display: flex;

    .el-input{
        flex:1;
    }
    }
</style>
